<template>
    <section id="content-annual-expenses">
        <h2>Annual Retained Expenses</h2>

        <div class="info-grid">
            <div v-if="listing.retained_expenses_lease" class="info-item-group list">
                <img src="./assets/building.svg" />
                <label>Lease:</label>
                <span>{{ listing.retained_expenses_lease | currency }}</span>
            </div>

            <div v-if="listing.retained_expenses_employees" class="info-item-group list">
                <img src="./assets/employees.svg" />
                <label>Employee:</label>
                <span>{{ listing.retained_expenses_employees | currency }}</span>
            </div>

            <div v-if="listing.retained_expenses_software" class="info-item-group list">
                <img src="./assets/gears.svg" />
                <label>Software:</label>
                <span>{{ listing.retained_expenses_software | currency }}</span>
            </div>

            <div v-if="listing.retained_expenses_other" class="info-item-group list">
                <img src="./assets/dots.svg" />
                <label>Other:</label>
                <span>{{ listing.retained_expenses_other | currency }}</span>
            </div>

            <div v-if="noAnnualExpenses" class="info-item-group list">
                <!-- <label>None</label> -->
                <span>None</span>
            </div>
    
            <div v-if="showEmptyCell" class="info-item-group empty"></div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'DetailsAnnualExpensesInformation',
    props: {
        listing: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        noAnnualExpenses () {
            let show_none = false;
            if (this.listing.retained_expenses_lease == null && this.listing.retained_expenses_employees == null && this.listing.retained_expenses_software == null && this.listing.retained_expenses_other == null) show_none = true

            return show_none
        },

        showEmptyCell () {
            let num = 0;
            if (this.listing.retained_expenses_lease != null) num++
            if (this.listing.retained_expenses_employees != null) num++
            if (this.listing.retained_expenses_software != null) num++
            if (this.listing.retained_expenses_other != null) num++
            if (this.noAnnualExpenses) num++
            
            return num % 2 == 0 ? false : true;
        },
    }
}
</script>

<style scoped>
    .info-grid {
        background-color: #EFEFEF;
    }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/AnnualExpensesInformation.vue